// client/src/pages/adminpages/PointPage.js
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import '../../styles/pages/AdminPages.css';
import '../../styles/admin/AdminSummary.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function getThisMonthRange() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end   = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const fmt = (d) => d.toISOString().slice(0, 10);
  return { startDate: fmt(start), endDate: fmt(end) };
}

export default function PointPage() {
  const navigate = useNavigate();

  const [expiredSummary, setExpiredSummary] = useState({ total: 0, expired: 0, cancel: 0, loading: true, error: false });
  const [completedSummary, setCompletedSummary] = useState({ count: 0, totalAmount: 0, loading: true, error: false });

  const loadExpired = useCallback(async () => {
    setExpiredSummary(s => ({ ...s, loading: true, error: false }));
    try {
      const r = await fetch(`${API_URL}/api/admin/point/bank-charge/expired`, { credentials: 'include' });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j?.ok) throw new Error();
      const items = j.items || [];
      setExpiredSummary({
        total:   items.length,
        expired: items.filter(i => i.status === 'expired').length,
        cancel:  items.filter(i => i.status === 'cancel').length,
        loading: false,
        error:   false,
      });
    } catch {
      setExpiredSummary({ total: 0, expired: 0, cancel: 0, loading: false, error: true });
    }
  }, []);

  const loadCompleted = useCallback(async () => {
    setCompletedSummary(s => ({ ...s, loading: true, error: false }));
    try {
      const { startDate, endDate } = getThisMonthRange();
      const r = await fetch(
        `${API_URL}/api/admin/point/bank-charge/completed?startDate=${startDate}&endDate=${endDate}`,
        { credentials: 'include' }
      );
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j?.ok) throw new Error();
      const items = j.items || [];
      const totalAmount = items.reduce((sum, i) => sum + (i.amount || 0), 0);
      setCompletedSummary({ count: items.length, totalAmount, loading: false, error: false });
    } catch {
      setCompletedSummary({ count: 0, totalAmount: 0, loading: false, error: true });
    }
  }, []);

  useEffect(() => {
    loadExpired();
    loadCompleted();
  }, [loadExpired, loadCompleted]);

  return (
    <AdminLayout title="포인트 관리">
      <div className="admin-page__dashboard">

        {/* 만료 / 취소 요청 카드 */}
        <div className="admin-page__section">
          <h2 className="admin-summary__title">만료 / 취소 요청</h2>
          <div className="admin-summary__box admin-summary__box--warning">
            {expiredSummary.loading && <div className="admin-summary__loading">불러오는 중...</div>}
            {!expiredSummary.loading && expiredSummary.error && (
              <div className="admin-summary__error">데이터를 불러오지 못했습니다.</div>
            )}
            {!expiredSummary.loading && !expiredSummary.error && (
              <div className="admin-summary__stats">
                <div className="admin-summary__stat-row">
                  <span className="admin-summary__stat-number admin-summary__stat-number--warning">
                    {expiredSummary.total}
                  </span>
                  건
                </div>
                <div style={{ fontSize: '14px', color: 'var(--admin-text-sub)', marginTop: 8 }}>
                  <span style={{ marginRight: 16 }}>
                    🟠 만료&nbsp;
                    <strong style={{ color: 'var(--admin-text-main)' }}>{expiredSummary.expired}</strong>건
                  </span>
                  <span>
                    ⚫ 취소&nbsp;
                    <strong style={{ color: 'var(--admin-text-main)' }}>{expiredSummary.cancel}</strong>건
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="admin-page__section-action">
            <button
              className="admin-page__action-button"
              type="button"
              onClick={() => navigate('/admin/point/bank-charge/check?tab=expired')}
            >
              관리
            </button>
          </div>
        </div>

        {/* 이번 달 충전 완료 카드 */}
        <div className="admin-page__section">
          <h2 className="admin-summary__title">이번 달 충전 완료</h2>
          <div className="admin-summary__box admin-summary__box--success">
            {completedSummary.loading && <div className="admin-summary__loading">불러오는 중...</div>}
            {!completedSummary.loading && completedSummary.error && (
              <div className="admin-summary__error">데이터를 불러오지 못했습니다.</div>
            )}
            {!completedSummary.loading && !completedSummary.error && (
              <div className="admin-summary__stats">
                <div className="admin-summary__stat-row">
                  <span className="admin-summary__stat-number admin-summary__stat-number--success">
                    {completedSummary.count}
                  </span>
                  건
                </div>
                <div style={{ fontSize: '15px', color: 'var(--admin-text-sub)', marginTop: 8, fontWeight: 500 }}>
                  {completedSummary.totalAmount.toLocaleString()}원
                </div>
              </div>
            )}
          </div>
          <div className="admin-page__section-action">
            <button
              className="admin-page__action-button"
              type="button"
              onClick={() => navigate('/admin/point/bank-charge/check?tab=completed')}
            >
              내역
            </button>
          </div>
        </div>

      </div>
    </AdminLayout>
  );
}
